import { global } from '../constants';

export const data = {
  banner: {
    background: global.banner + 'cash.jpg',
    title: 'Bank Notes',
    crumb: 'Industries / Bank Notes',
  },
  intro: {
    img: global.banner + 'money.jpg',
    tagline: 'Confidence in Every Note’s Journey',
    heading:
      'Aligning precision, expertise, and infrastructure to support trusted currency flow',
    description:
      'From initial production to market circulation, our approach ensures banknotes move with care, consistency, and control — backed by decades of operational know-how and purpose-built infrastructure.',
  },

  estimation: {
    background: global.banner + 'cash-2.png',
    title: 'Unmatched Expertise in Banknote Logistics',
    subtitle: 'OUR CORE CAPABILITIES',
    description:
      'We provide discreet and reliable banknote logistics solutions built to meet the highest industry standards. Every stage of the journey is handled with precision, ensuring your currency moves seamlessly and securely worldwide.',
    solutions: [
      {
        serial: '01',
        icon: global.eicons + 'pic1.png',
        title: 'Lifecycle Management',
        description:
          'Expertly overseeing banknotes from initial production facilities through highly controlled global distribution networks, ensuring seamless movement and strict security at every stage.',
      },
      {
        serial: '02',
        icon: global.eicons + 'pic2.png',
        title: 'Vault & Custody Network',
        description:
          'Providing access to a trusted network of accredited vaults and bonded facilities located in major financial hubs worldwide, designed to safeguard assets with the highest security standards.',
      },
      {
        serial: '03',
        icon: global.eicons + 'pic3.png',
        title: 'Precision Handling',
        description:
          'Implementing tailored protocols and meticulous handling procedures that uphold the integrity, confidentiality, and quality of banknotes throughout their entire journey.',
      },
    ],
  },
  whychoosus: {
    firstImage: global.banner + 'firstCash.png',
    secondImage: global.banner + 'secondCash.jpg',
    title: 'Beyond Delivery',
    subtitle: 'Partnering for reliability in every financial flow',
    description: {
      short:
        'We provide end-to-end cash cycle solutions that prioritize precision, discretion, and institutional confidence.',
      long: 'Our commitment goes beyond delivery; it’s about creating a trusted environment where central banks, printing authorities, and financial institutions operate with clarity and control. Every note handled is a reflection of integrity, accountability, and readiness for tomorrow’s demands.',
    },
  },
};
